import VideoUIServant from './jce/VideoUIServant'
import cookie from 'amkit3-modules/utils/cookie'
import callWup from './fetch'

const defaultUid = cookie.get('udb_uid')

const UI_NAME = 'videoui'
const sHuYaUA = 'web&1.0.0&huyavideo'

export function userClickVideo({ lUid = '50041702', sVideoId = '50077020', sdid = '' } = {}) {

  const req = new VideoUIServant.UserClickVideoReq();
  req.tId.lUid = lUid || defaultUid
  req.tId.sHuYaUA = sHuYaUA
  req.sVideoId = sVideoId
  req.sdid = sdid
  return callWup(UI_NAME, `userClickVideo`, req, VideoUIServant.UserClickVideoRsp);
}

export  function userViewVideo({  lUid = '50041702', sVideoId = '50077020', sdid = '', } = {}) {

  const req = new VideoUIServant.UserViewVideoReq();
  req.tId.lUid = lUid || defaultUid
  req.tId.sHuYaUA = sHuYaUA
  req.sVideoId = sVideoId
  req.sdid = sdid

  return callWup(UI_NAME, `userViewVideo`, req, VideoUIServant.UserViewVideoRsp);
}

/**
 * 
 * @param 
 *  sViewId;                                 // 观看场次id
   sdid;                                    // 设备指纹id
   map<string, string>            mExt;                                    // 附带信息	 network:-1不知道 0没网络 1Wi-Fi 2蜂窝网/screen:0半屏 1全屏/volume:80
   int                            iState = 0;                              // other0 , buffer1,  play2,  pause3,  error4,  end5
   long                           lCurPos = 0;                             // 当前观看的进度，单位秒} param0 
 */

export function userViewVideoHeartBeat({  lUid = '50041702', sVideoId = '50077020', sdid = '', sViewId,  mExt, iState = 0, lCurPos = 0 } = {}) {

  const req = new VideoUIServant.UserViewVideoHeartBeatReq();
  req.tId.lUid = lUid || defaultUid
  req.tId.sHuYaUA = sHuYaUA
  req.sVideoId = sVideoId
  req.sdid = sdid
  req.sViewId= sViewId
  req.mExt.value = mExt
  req.iState = iState
  req.lCurPos = lCurPos

  return callWup(UI_NAME, `userViewVideoHeartBeat`, req, VideoUIServant.UserViewVideoHeartBeatRsp);
}

export function userViewVideoEnd({ lUid = '50041702', sVideoId = '50077020', sdid = '', sViewId } = {}) {

  const req = new VideoUIServant.UserViewVideoEndReq();
  req.tId.lUid = lUid || defaultUid
  req.tId.sHuYaUA = sHuYaUA
  req.sVideoId = sVideoId
  req.sdid = sdid
  req.sViewId = sViewId
  return callWup(UI_NAME, `userViewVideoEnd`, req, VideoUIServant.UserViewVideoEndRsp);
}

export function userRealPlayVideo({  lUid = '50041702', sVideoId = '50077020', sdid = '' } = {}) {

  const req = new VideoUIServant.UserRealPlayVideoReq();
  req.tId.lUid = lUid || defaultUid
  req.tId.sHuYaUA = sHuYaUA
  req.sVideoId = sVideoId
  req.sdid = sdid

  return callWup(UI_NAME, `userRealPlayVideo`, req, VideoUIServant.UserRealPlayVideoRsp);
}

export function userBehavior({  lUid = '50041702', sVideoId = '50077020', sdid = '', sViewId, mBehavior ={} } = {}) {

  const req = new VideoUIServant.UserBehaviorReq();
  req.tId.lUid = lUid || defaultUid
  req.tId.sHuYaUA = sHuYaUA
  req.sVideoId = sVideoId
  req.sdid = sdid
  req.sViewId = sViewId
  req.mBehavior.value = mBehavior

  return callWup(UI_NAME, `userBehavior`, req, VideoUIServant.UserBehaviorRsp);
}
